import { css, cx } from '@onbeam/business-styled-system/css';

type Props = {
  name: string;
  x: number;
  y: number;
  scale: number;
  width: number;
  height: number;
};

export const IntroSectionVideo = ({
  name,
  x,
  y,
  scale,
  width,
  height,
}: Props) => {
  const videoAttributes = {
    autoPlay: true,
    loop: true,
    muted: true,
    playsInline: true,
    style: {
      left: x * scale,
      top: y * scale,
      width: width * scale,
      height: height * scale,
    },
  };

  const className = css({
    pos: 'absolute',
    objectFit: 'contain',
    pointerEvents: 'none',
    zIndex: -1,
  });

  return (
    <>
      <video
        className={cx(className, css({ _dark: { display: 'none' } }))}
        {...videoAttributes}
      >
        <source
          src={`https://d1sbvhbby74rp9.cloudfront.net/${name}-light.mp4`}
          type="video/mp4"
        />
      </video>
      <video
        className={cx(className, css({ _light: { display: 'none' } }))}
        {...videoAttributes}
      >
        <source
          src={`https://d1sbvhbby74rp9.cloudfront.net/${name}-dark.mp4`}
          type="video/mp4"
        />
      </video>
    </>
  );
};
